// import '@babel/polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import Amplify from 'aws-amplify'
import aws_exports from './aws-exports'
import Vuelidate from 'vuelidate'
import global from './mixins/global'
import { i18n } from './plugins/vue-i18n'

Vue.mixin(global)

Amplify.configure(aws_exports)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.component('AppLink', () => import('./components/AppLink'))

Vue.use(Vuelidate)

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  i18n,
  template: '<App/>',
  components: {
    App
  }
})
